/*
 *
 */
import React                              from 'react'
import Grid                               from "@material-ui/core/Grid"
import PropTypes                          from 'prop-types'
import Typography                         from "@material-ui/core/Typography"

const TpsClassYearsThatNeedNote = ( { tpsClass } ) => {
 
   return(
      <Grid>
         <Typography align='left' >
            The designation "Class [{tpsClass}]" is used here as an organizational
            identifier for consistency across the site. Whether this cohort carried
            a formal lettered designation at the time is an open research question.
            See the History page for more context.
         </Typography>
      </Grid>
   )
}

TpsClassYearsThatNeedNote.propTypes = {
    tpsClass: PropTypes.string
}

export default TpsClassYearsThatNeedNote